/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayRankControllerDtoRankDetailSettingUpdateRequest model module.
 * @module model/PerplayRankControllerDtoRankDetailSettingUpdateRequest
 * @version 1.0
 */
class PerplayRankControllerDtoRankDetailSettingUpdateRequest {
    /**
     * Constructs a new <code>PerplayRankControllerDtoRankDetailSettingUpdateRequest</code>.
     * @alias module:model/PerplayRankControllerDtoRankDetailSettingUpdateRequest
     */
    constructor() { 
        
        PerplayRankControllerDtoRankDetailSettingUpdateRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PerplayRankControllerDtoRankDetailSettingUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayRankControllerDtoRankDetailSettingUpdateRequest} obj Optional instance to populate.
     * @return {module:model/PerplayRankControllerDtoRankDetailSettingUpdateRequest} The populated <code>PerplayRankControllerDtoRankDetailSettingUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayRankControllerDtoRankDetailSettingUpdateRequest();

            if (data.hasOwnProperty('settingNo')) {
                obj['settingNo'] = ApiClient.convertToType(data['settingNo'], 'Number');
            }
            if (data.hasOwnProperty('rankType')) {
                obj['rankType'] = ApiClient.convertToType(data['rankType'], 'Number');
            }
            if (data.hasOwnProperty('lastRank')) {
                obj['lastRank'] = ApiClient.convertToType(data['lastRank'], 'Number');
            }
            if (data.hasOwnProperty('targetType')) {
                obj['targetType'] = ApiClient.convertToType(data['targetType'], 'Number');
            }
            if (data.hasOwnProperty('withoutTarget')) {
                obj['withoutTarget'] = ApiClient.convertToType(data['withoutTarget'], 'String');
            }
            if (data.hasOwnProperty('rankDetail')) {
                obj['rankDetail'] = ApiClient.convertToType(data['rankDetail'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayRankControllerDtoRankDetailSettingUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayRankControllerDtoRankDetailSettingUpdateRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['withoutTarget'] && !(typeof data['withoutTarget'] === 'string' || data['withoutTarget'] instanceof String)) {
            throw new Error("Expected the field `withoutTarget` to be a primitive type in the JSON string but got " + data['withoutTarget']);
        }
        // ensure the json data is a string
        if (data['rankDetail'] && !(typeof data['rankDetail'] === 'string' || data['rankDetail'] instanceof String)) {
            throw new Error("Expected the field `rankDetail` to be a primitive type in the JSON string but got " + data['rankDetail']);
        }

        return true;
    }


}



/**
 * @member {Number} settingNo
 */
PerplayRankControllerDtoRankDetailSettingUpdateRequest.prototype['settingNo'] = undefined;

/**
 * @member {Number} rankType
 */
PerplayRankControllerDtoRankDetailSettingUpdateRequest.prototype['rankType'] = undefined;

/**
 * @member {Number} lastRank
 */
PerplayRankControllerDtoRankDetailSettingUpdateRequest.prototype['lastRank'] = undefined;

/**
 * @member {Number} targetType
 */
PerplayRankControllerDtoRankDetailSettingUpdateRequest.prototype['targetType'] = undefined;

/**
 * @member {String} withoutTarget
 */
PerplayRankControllerDtoRankDetailSettingUpdateRequest.prototype['withoutTarget'] = undefined;

/**
 * @member {String} rankDetail
 */
PerplayRankControllerDtoRankDetailSettingUpdateRequest.prototype['rankDetail'] = undefined;






export default PerplayRankControllerDtoRankDetailSettingUpdateRequest;

